module.exports = __webpack_public_path__ + "static/media/Kirkway-Estates-Master-Deed-1.fed9ec12.pdf";